import React, { useCallback, SyntheticEvent } from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import Cancel from '@kyruus/react-ikons/Cancel';
import Button from '@kyruus/button';
import { AppDrawer, APP_DRAWER_IDS } from 'Src/app-drawer';
import { getProviderDisplayName } from 'Src/provider/utils';
import { Log, ExtendedProvider } from 'Src/types';
import { Content, Header, Heading } from './styles';
import { messages } from './messages';
interface BaseCtaDrawerProps {
  id: string;
  log: Log;
  onClose: (e: SyntheticEvent) => void;
  provider?: ExtendedProvider;
}

type CtaDrawerProps = WrappedComponentProps & BaseCtaDrawerProps;

export const CtaDrawer = injectIntl(
  ({ intl, onClose, log, provider }: CtaDrawerProps) => {
    const closeButtonRef = useCallback((closeButtonNode) => {
      if (closeButtonNode) {
        closeButtonNode.focus();
      }
    }, []);
    const handleClose = (
      event: SyntheticEvent,
      reason?: 'closeIcon' | 'escapeKeyDown' | 'backdropClick'
    ) => {
      log(`user_action.alter_view.request_appointment.${reason}`, {
        providerId: provider?.id
      });
      onClose(event);
    };

    const headingId = `${APP_DRAWER_IDS.CTA_DRAWER}-title`;
    return (
      <AppDrawer
        id={APP_DRAWER_IDS.CTA_DRAWER}
        onClose={handleClose}
        aria-labelledby={headingId}
      >
        {provider && (
          <>
            <Header>
              <Heading id={headingId}>
                {intl.formatMessage(messages.ctaDrawerHeading, {
                  providerName: getProviderDisplayName(provider)
                })}
              </Heading>
              <Button
                aria-controls={APP_DRAWER_IDS.CTA_DRAWER}
                aria-label={intl.formatMessage(
                  messages.closeCtaDrawerAriaLabel
                )}
                data-testid="close-drawer-button"
                mode="flat"
                onClick={(e) => handleClose(e, 'closeIcon')}
                ref={closeButtonRef}
              >
                <Cancel size="1.6em" aria-hidden="true" />
              </Button>
            </Header>
            <Content></Content>
          </>
        )}
      </AppDrawer>
    );
  }
);
